/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Invite_TitleInputs */

const es_admin_users_invite_title = /** @type {(inputs: Admin_Users_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitar nuevo usuario`)
};

const en_admin_users_invite_title = /** @type {(inputs: Admin_Users_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite new user`)
};

/**
* | output |
* | --- |
* | "Invite new user" |
*
* @param {Admin_Users_Invite_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_invite_title = /** @type {((inputs?: Admin_Users_Invite_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Invite_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_invite_title(inputs)
	return en_admin_users_invite_title(inputs)
});
export { admin_users_invite_title as "admin.users.invite.title" }